import { firebaseAnalyticsAdapter } from '@/adapters/analytics';
import { createUserAwareAnalyticsAdapter } from '@/adapters/analytics/createUserAwareAnalyticsAdapter';
import { getCurrentAccountId } from '@/adapters/analytics/currentAccountId';
import { getCurrentUserId } from '@/adapters/analytics/currentUserId';
import {
  createNotificationAnalyticsStore,
  type NotificationAnalyticsAdapters,
} from '@/stores/createNotificationAnalyticsStore';

const productionAdapters: NotificationAnalyticsAdapters = {
  analytics: createUserAwareAnalyticsAdapter(
    firebaseAnalyticsAdapter,
    () => getCurrentUserId(),
    () => getCurrentAccountId(),
  ),
};

const useNotificationAnalyticsStore = createNotificationAnalyticsStore(productionAdapters);

export { useNotificationAnalyticsStore };
